import { 
    getHistoryReport,
    getLandlordReportExcel,
    updateReconcileStatus,
    deteleStatement
} from "@/apis/company/landlordReport.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_landlord_report_history_obj: 'landlordReportHistory/set_landlord_report_history_obj',
    set_landlord_report_data: 'landlordReportHistory/set_landlord_report_data',
    set_build_report: 'landlordReportHistory/set_build_report',
    set_filter_query: 'landlordReportHistory/set_filter_query',
    set_filter_word: 'landlordReportHistory/set_filter_word',
    set_filter_result: 'landlordReportHistory/set_filter_result',
    set_filter_default: 'landlordReportHistory/set_filter_default',

}

// count state 必須是 Object
const state = {
    landlordReportHistoryObj: null,
    landlordReportDate: [],
    filterQuery: {
        status: '',
        date: []
    },
    filterWord: '',
    filterResult: [],
    buildReport: {
        statementId: null,
        targetType: null,
        targetId: null,
        startDate: null,
        endDate: null,
        reconciled: null,
        moneyType: null,
        moneyItemList: [],
        excludeZeroLedger: false,
        excludeZeroBill: false,

    },
    mode: null,
    isDefault: false,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LANDLORD_REPORT_HISTORY_LIST: (state) => {
        return state.landlordReportHistoryObj?state.landlordReportHistoryObj.statements:[]
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_ADDRESS: (state) => {
        return state.landlordReportHistoryObj?state.landlordReportHistoryObj.targetName:''
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_BUILD_REPORT: (state) => {
        return state.buildReport
    },
    GET_BIZ_LANDLORD_REPORT_HISTORY_TOTAL: (state) => {
        const list = state.filterResult
        let data = {
            income: 0,
            incomeCount: 0,
            expense: 0,
            expenseCount: 0,
            payable: 0,
            payableCount: 0
        } 
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            data.income += element.amountVO.totalIncomeAmount
            data.incomeCount += element.amountVO.totalIncomeAmount?1:0
            data.expense += element.amountVO.totalExpenseAmount
            data.expenseCount += element.amountVO.totalExpenseAmount?1:0
            data.payable += element.amountVO.payableAmount,
            data.payableCount += element.amountVO.payableAmount?1:0
        }
        return data
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLandlordReportHistoryList ( {commit, state}, params ) {
        return new Promise((resolve, reject) => {
            getHistoryReport(params)
            .then(res => {
                console.log('apiBizGetlandlordReportHistory',res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_landlord_report_history_obj, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getBizLandlordReportExcel ( {commit}, params ) {
        return new Promise((resolve, reject) => {
            getLandlordReportExcel(params)
            .then(res => {
                console.log(res)
                if( res.status === 200 ){
                    resolve(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizReconcileStatus ( {dispatch, commit}, data ) {
        return new Promise((resolve, reject) => {
            updateReconcileStatus(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    bizDeteleStatement ( {dispatch, commit}, data ) {
        return new Promise((resolve, reject) => {
            deteleStatement(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('setAlarmStatus', {status: true,title: '報表刪除成功',type: 'success'})
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    setBizLandlordReportHistoryFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizLandlordReportHistoryFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizLandlordReportHistoryFilterResult ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result, value);
            resolve()
        })
    },
    setBizLandlordReportHistoryFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                status: '',
                date: []
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
    setBizBuildReport ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_report_data, data);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_landlord_report_history_obj](state, data){
        state.landlordReportHistoryObj = data
    },
    [types.set_landlord_report_data](state, data){
        Object.assign(state.buildReport, data)
        // state.buildReport.startDate = state.filterQuery.date[0]
        // state.buildReport.endDate = state.filterQuery.date[1]
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result](state, data){
        state.filterResult = data
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/landlordReportHistory.js